uniform vec2 resolution;
varying vec2 vUv;

void main() {
    // Convert UV coordinates to screen space coordinates
    vec2 screenCoords = vUv * resolution;

    float y = step(20.0, mod(screenCoords.y, 40.0));

    float add = y * 20.0;

    // Calculate the stripe pattern
    float x = step(20.0, mod(add + screenCoords.x, 40.0));

    float stripePattern = x;
    
    //mod(floor(screenCoords.x / 20.0) + floor(screenCoords.y / 20.0), 1.0);

    vec2 st = gl_FragCoord.xy / resolution.xy;
    vec4 color = vec4(st.x, st.y, 1.0, 1.0);
    vec4 noColor = vec4(0.0);

    gl_FragColor = mix(color, noColor, stripePattern);
    //gl_FragColor = vec4(vUv.y, vUv.x, 0.0, 1.0);
}